<script setup>
import CenterLayout from "./CenterLayout.vue";
import { Icon, Input, Textarea } from "@components";
import { ref } from "vue";

import { useChatCustomizer } from "@store/chatCustomizer";
const $chatCustomizer = useChatCustomizer();

import { useSettings } from "@store/settings";
const $settings = useSettings();

const default_banner =
  prebook_admin?.url?.assets + "images/chat-customizer-top-banner.jpeg";
</script>

<template>
  <CenterLayout>
    <div
      class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10"
      :style="{
        'background-color': $settings.customizer?.design?.brand_color,
      }"
    >
      <img
        v-if="$settings.settings.chat_widget.banner.image"
        :src="$settings.settings.chat_widget.banner.image"
        class="cursor-pointer"
        alt=""
      />
      <img
        v-else
        :src="default_banner"
        class="cursor-pointer"
        alt=""
        style="object-fit: cover; width: 100%; height: -webkit-fill-available"
      />
    </div>

    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div
      class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto"
      style="box-shadow: 0px 50px 76px -2px rgba(11, 17, 29, 0.1)"
    >
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Input
          v-model="$settings.settings.chat_widget.welcome.question"
        ></Input>
      </div>
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Caption</div>
        <Textarea
          v-model="$settings.settings.chat_widget.welcome.answer"
        ></Textarea>
      </div>
    </div>
    <div class="mt-10 text-center font-semibold text-lg">...</div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">
          Welcome Title
        </div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Set your welcome title</li>
          <li>Describe your idea in caption</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>

<style></style>
